export default "__VITE_ASSET__d8W0awDF__"